<template>
  <div>
    <div class="mb-4">
      <div class="w-full mb-4">
        <strong>{{ name }}</strong>
      </div>

      <div class="w-full">
        <div v-for="(item, indexItem) in items" :key="indexItem">
          <template>
            <div class="mb-2">
              <vs-checkbox 
                :vs-value="indexItem" 
                :index="indexItem" 
                v-model="selecteds"
                @change="updateSelected"
                :name="'selected' + index"
                v-validate="isRequired ? 'required' : '' "
                :disabled="disabled"
              >
                {{ item.description }}
              </vs-checkbox>
            </div>
          </template>
        </div>
        <span class="text-danger text-sm" v-show="errors.has('selected' + index)">
          Preenchimento do campo é obrigatório.
        </span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CheckboxField',
    inject: ['$validator'],
    props: {
      index: {
        type: Number,
        required: true
      },
      items: {
        type: Array,
        required: false
      },
      description: {
        required: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
    },
    data() {
      return {
        selecteds: [],
        isRequired: false
      }
    },
    computed:  {
      name(){
        if ( !this.description || this.description.description == ''){
          return;
        } 
        else if ( this.description.description ){
          return this.description.description;
        }
        return this.description;
      }
    },
    methods: {
      updateSelected () {
        this.items.forEach((item, idx) => {
          let flag = this.selecteds.includes(idx)
          this.$emit('valueChanged', this.index, idx, flag)
        })
      }
    },
    created() {
      if (!this.items) { return;}
      this.items.forEach((item, idx) => {
        this.isRequired = item.reason_option_is_required

        if(!item.value || item.value.toLowerCase() == 'false'){ return; }
        this.selecteds.push(idx)
      })
    }
  }
</script>
